// import React, { createContext, useState, useEffect } from "react";
// import Cookies from "js-cookie";
// import { jwtDecode } from "jwt-decode";
// import { useNavigate } from "react-router-dom";
// import LoadingScreen from "../Components/LoadingScreen";

// export const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [token, setToken] = useState(null);
//   const [allowedModules, setAllowedModules] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const navigate = useNavigate();

//   const redirectUser = (role, modules) => {
//     const roleLower = (role || "").toLowerCase();

//     // PMS → PMS Dashboard
//     if (modules.includes("pms")) {
//       navigate("/index", { replace: true });
//       return;
//     }

//     // HRMS → employee or admin
//     if (modules.includes("hrms")) {
//       if (roleLower === "employee") {
//         navigate("/user/dashboard", { replace: true });
//         return;
//       }

//       navigate("/hrms-dashboard", { replace: true });
//       return;
//     }

//     // No valid module → go to login
//     navigate("/signin", { replace: true });
//   };

//   // ------------------------------------------
//   // ⭐ CHECK TOKEN ON INITIAL PAGE LOAD
//   // ------------------------------------------
//   useEffect(() => {
//     const checkToken = () => {
//       const storedToken = Cookies.get("authToken");

//       if (!storedToken) {
//         setLoading(false);
//         navigate("/signin", { replace: true });
//         return;
//       }

//       try {
//         const decoded = jwtDecode(storedToken);

//         if (decoded.exp * 1000 < Date.now()) {
//           Cookies.remove("authToken");
//           setLoading(false);
//           navigate("/signin", { replace: true });
//           return;
//         }

//         const userInfo = {
//           name: decoded.name || decoded.username || null,
//           email: decoded.email || null,
//           role: decoded.role || null,
//           property_name: decoded.property_id || null,
//           property_code: decoded.property_code || null,
//         };

//         // Save user/session
//         setUser(userInfo);
//         setToken(storedToken);
//         setAllowedModules(decoded.modules || []);

//         // After token validation → stop loading
//         setLoading(false);

//         // Auto redirect ONLY from root or signin
//         const path = window.location.pathname;
//         if (path === "/" || path === "/signin") {
//           redirectUser(decoded.role, decoded.modules || []);
//         }
//       } catch (err) {
//         Cookies.remove("authToken");
//         setLoading(false);
//         navigate("/signin", { replace: true });
//       }
//     };

//     checkToken();
//   }, []);

//   // ------------------------------------------
//   // ⭐ LOGIN (called after user signs in)
//   // ------------------------------------------
//   const login = (jwtToken) => {
//     Cookies.set("authToken", jwtToken);

//     const decoded = jwtDecode(jwtToken);

//     const userInfo = {
//       name: decoded.name || decoded.username || null,
//       email: decoded.email || null,
//       role: decoded.role || null,
//       property_name: decoded.property_id || null,
//       property_code: decoded.property_code || null,
//     };

//     setUser(userInfo);
//     setToken(jwtToken);
//     setAllowedModules(decoded.modules || []);

//     redirectUser(decoded.role, decoded.modules || []);
//   };

//   // ------------------------------------------
//   // ⭐ LOGOUT
//   // ------------------------------------------
//   const logout = () => {
//     Cookies.remove("authToken");
//     setUser(null);
//     setToken(null);
//     setAllowedModules([]);
//     navigate("/signin", { replace: true });
//   };

//   if (loading) return <LoadingScreen />;

//   return (
//     <AuthContext.Provider
//       value={{ user, token, allowedModules, login, logout }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// };

import React, { createContext, useState, useEffect } from "react";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import LoadingScreen from "../Components/LoadingScreen";
import { usePmsStore } from "../Store/pmsStore";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [allowedModules, setAllowedModules] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  const redirectUser = (role, modules) => {
    const roleLower = (role || "").toLowerCase();

    if (modules.includes("pms")) {
      navigate("/index", { replace: true });
      return;
    }

    if (modules.includes("hrms")) {
      if (roleLower === "employee") {
        navigate("/user/dashboard", { replace: true });
        return;
      }

      navigate("/hrms-dashboard", { replace: true });
      return;
    }

    navigate("/signin", { replace: true });
  };

  useEffect(() => {
    const checkToken = async () => {
      const storedToken = Cookies.get("authToken");

      if (!storedToken) {
        setLoading(false);
        navigate("/signin", { replace: true });
        return;
      }

      try {
        const decoded = jwtDecode(storedToken);

        if (decoded.exp * 1000 < Date.now()) {
          Cookies.remove("authToken");
          setLoading(false);
          navigate("/signin", { replace: true });
          return;
        }

        const userInfo = {
          name: decoded.name || decoded.username || null,
          email: decoded.email || null,
          role: decoded.role || null,
          property_name: decoded.property_id || null,
          property_code: decoded.property_code || null,
        };

        setUser(userInfo);
        setToken(storedToken);
        setAllowedModules(decoded.modules || []);

        // if ((decoded.modules || []).includes("pms")) {
        //   usePmsStore.getState().loadFromCache();

        //   usePmsStore
        //     .getState()
        //     .loadAllApis()
        //     .catch(() => {});
        // }

        setLoading(false);

        const path = window.location.pathname;
        if (path === "/" || path === "/signin") {
          redirectUser(decoded.role, decoded.modules || []);
        }
      } catch (err) {
        Cookies.remove("authToken");
        setLoading(false);
        navigate("/signin", { replace: true });
      }
    };

    checkToken();
  }, []);

  const login = async (jwtToken) => {
    Cookies.set("authToken", jwtToken);

    const decoded = jwtDecode(jwtToken);

    const userInfo = {
      name: decoded.name || decoded.username || null,
      email: decoded.email || null,
      role: decoded.role || null,
      property_name: decoded.property_id || null,
      property_code: decoded.property_code || null,
    };

    setUser(userInfo);
    setToken(jwtToken);
    setAllowedModules(decoded.modules || []);

    // if ((decoded.modules || []).includes("pms")) {
    //   await usePmsStore.getState().loadAllApis();
    // }

    redirectUser(decoded.role, decoded.modules || []);
  };

  const logout = () => {
    Cookies.remove("authToken");
    setUser(null);
    setToken(null);
    setAllowedModules([]);

    usePmsStore.getState().clearPms();

    navigate("/signin", { replace: true });
  };

  if (loading) return <LoadingScreen />;

  return (
    <AuthContext.Provider
      value={{ user, token, allowedModules, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};
